import React, { memo } from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { DisplayAdWidget } from '../../ads/displayAdWidget.jsx';
import { DisplayAdUnit } from '../../../containers/ads/displayAdUnitContainer';

interface ForecastListAdBreakProps {
    adIndex: number;
    isDailyAd?: boolean;
}

export const ForecastListAdBreak = memo(({ adIndex, isDailyAd=false }: ForecastListAdBreakProps) => {

    const slotId = isDailyAd ? 'forecasts/daily_cards_scroll_x13' : 'forecasts/hourly_hourly_card_list_infinite';

    return (
        <Container key={slotId}>
            <DisplayAdUnit
                isInfiniteScrollAd={!isDailyAd} 
                infiniteScrollIndex={adIndex}
                slotId={slotId} 
                width={300} 
                height={250} />
        </Container>
    );
});

ForecastListAdBreak.displayName = 'ForecastListAdBreak';

const Container = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 4px;
    @media ${smallMediaQuery} {
        margin: 4px 0;
    }
`;